import axios from "../axios";

const createChildPartner = async function (accessToken,params = {}) {
    try {
        const response = await axios.post('child-partner/createChildPartner', params ,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default createChildPartner;
